import { isEmpty, isUndefined } from "lodash-es";
import { toFixed } from "../calculator";
import { isNumber } from "./number";

export const isComma = (val) => {
  return isEmpty(val) || isNumber(restoreComma(val));
};

export const transformComma = (val, fixed) => {
  if (!val) return val || 0
  let translation = "";
  val = restoreComma(val)
  if (fixed) val = toFixed(val);
  var regexp = /\B(?=(\d{3})+(?!\d))/g;

  if (!isUndefined(val)) translation = val.toString().replace(regexp, ",");
  return translation;
};

export const restoreComma = (val) => {
  let isNegative = false
  let translation = ""
  const _val = String(val)
  const number = Number(_val.replace(/,/g, ""))
  if (number < 0 || _val === '-') isNegative = true
  translation = _val.replace(/[^0-9]/g, "")
  return isNegative ? `-${translation}` : translation
}
